import { Component, OnInit } from '@angular/core';
import { ToastMessage, ToastService } from '../toast.service';


interface AnimatedToast extends ToastMessage {
  visible: boolean;
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit {
  toasts: AnimatedToast[] = [];

  constructor(private toastService: ToastService) { }

  ngOnInit() {
    this.toastService.toastState.subscribe((toast: ToastMessage) => {
      const newToast: AnimatedToast = { ...toast, visible: true };
      this.toasts.push(newToast);

      // Fade out after 2.5s
      setTimeout(() => {
        newToast.visible = false;
      }, 2500);

      // Remove from DOM after fade out (3s)
      setTimeout(() => {
        this.toasts = this.toasts.filter(t => t !== newToast);
      }, 3000);
    });
  }
}
